<div class="dialog-box">
  <div class="dialog-box__content deductions-content">
    <div class="title d-flex align-items-center">
      @if (selectButton.imageSrc) {
        <img src="{{ selectButton.imageSrc }}" />
      }
      @if (selectButton.label) {
        <span>
          {{ selectButton.label | translate }}
        </span>
      }
      <button mat-icon-button mat-dialog-close="" tabindex="-1">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>

    @if (tooltip && type !== 'volunteering_income') {
      <div class="description">
        <app-more-info-tooltip
          [alignLeft]="true"
          [isSmall]="true"
          [showText]="true"
          [message]="tooltipMsg"
        ></app-more-info-tooltip>
      </div>
    }

    @if (type === 'volunteering_income') {
      <div class="description">
        <app-more-info-tooltip
          [alignLeft]="true"
          [isSmall]="true"
          [showText]="true"
          [titleTooltip]="'ADDITIONAL_INCOME.FREELANCE_GROUP.VOLUNTERING_INCOME.TOOLTIP.TITLE'"
          [contentTemplateRef]="volunteringIncomeTooltipRef"
        ></app-more-info-tooltip>
      </div>
    }

    <div class="dialog-box__form mt-1">
      <div class="dialog-box__form-content">
        <ng-container>
          <app-additional-income-dialog-edit
            [mainStatement]="mainStatement"
            [currentStatement]="currentStatement"
            [title]="selectButton.label"
            [incomeType]="type"
            [epValidator]="epValidator"
            [isBusiness]="isBusiness"
            [icon]="selectButton.imageSrc"
            [appShowFormError]
          ></app-additional-income-dialog-edit>
        </ng-container>
      </div>

      <div class="dialog-box__form-buttons">
        <button class="btn btn--secondary btn--small" mat-dialog-close>{{ "COMMON.CANCEL" | translate }}</button>
        <button
          class="btn btn--primary btn--longer"
          [class.is-loading]="additionalIncomeService.isLoading"
          (click)="save()"
          >
          {{ "COMMON.SAVE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- TOOLTIPS TEMPLATES -->
<ng-template #volunteringIncomeTooltipRef>
  <app-tooltip-voluntering-income></app-tooltip-voluntering-income>
</ng-template>
